import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Alert
} from '@mui/material';
import FilledButton from './FilledButton';
import OutlinedButton from './OutlinedButton';
import { Editor } from '@tinymce/tinymce-react';
import { updateComment } from '../services/api';

const EditCommentDialog = ({ open, onClose, comment, onUpdated, onSuccess }) => {
  const [content, setContent] = useState('');
  const [saving, setSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (open) {
      setContent(comment?.content || '');
      setSaving(false);
    }
  }, [open, comment]);

  const handleSave = async () => {
    if (!comment) return;
    setSaving(true);
    try {
      await updateComment(comment.id, { content });
      if (onUpdated) onUpdated(content);
      const msg = 'Comment updated';
      if (onSuccess) onSuccess(msg); else setSuccessMessage(msg);
      onClose();
    } catch (err) {
      console.error('Failed to update comment:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Comment</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Editor
          tinymceScriptSrc="/tinymce/tinymce.min.js"
          value={content}
          init={{
            license_key: 'gpl',
            height: 200,
            menubar: false,
            plugins: ['link', 'lists', 'autolink', 'charmap', 'table'],
            toolbar:
              'undo redo | bold italic underline | bullist numlist outdent indent',
          }}
          onEditorChange={(c) => setContent(c)}
        />
      </DialogContent>
      <DialogActions>
        <OutlinedButton onClick={onClose} text="Cancel" color="success" />
        <FilledButton
          onClick={handleSave}
          disabled={saving || !content}
          text="Save"
          color="success"
        />
      </DialogActions>
    </Dialog>
    <Snackbar
      open={!!successMessage}
      autoHideDuration={3000}
      onClose={() => setSuccessMessage('')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={() => setSuccessMessage('')} severity="success" sx={{ width: '100%', fontWeight: 'bold' }}>
        {successMessage}
      </Alert>
    </Snackbar>
    </>
  );
};

export default EditCommentDialog;
